import { getTheme, mergeStyleSets, Stack, Text } from "@fluentui/react";
import ExtensionsComboBox from "./ExtensionsCombox";
import { ExtensionFolder } from "../Types";

interface ExperimentTableSelectExtensionProps {
  extensionName: string;
  extensions: ExtensionFolder[];
}

const ExperimentTableSelectExtension: React.FC<
  ExperimentTableSelectExtensionProps
> = ({ extensionName, extensions }) => {
  return (
    <Stack
      horizontalAlign="center"
      verticalAlign="center"
      tokens={{ childrenGap: 20, padding: 40 }}
      className={styles.experimentTableSelectExtension}
    >
      <Stack tokens={{ childrenGap: 8 }} horizontalAlign="center">
        <Text
          variant="xLarge"
          className={styles.experimentTableSelectExtensionText}
        >
          Please select an extension
        </Text>
        <Text
          variant="medium"
          className={styles.experimentTableSelectExtensionSubtitle}
        >
          Choose an extension to view and manage experiments
        </Text>
      </Stack>
      <ExtensionsComboBox extensions={extensions} selected={extensionName} />
    </Stack>
  );
};

const theme = getTheme();

const styles = mergeStyleSets({
  experimentTableSelectExtension: {
    borderRadius: 5,
  },
  experimentTableSelectExtensionText: {
    fontWeight: 600,
    color: theme.palette.neutralPrimary,
  },
  experimentTableSelectExtensionSubtitle: {
    color: theme.palette.neutralPrimary,
    marginBottom: 8,
  },
});

export default ExperimentTableSelectExtension;
